<template>
  <div>
    <div class="" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'10px' }">
      <i class="bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
         v-bind:style="{ fontSize : '15px'}"></i>
      <i class="bi bi-save-fill" v-bind:style="{ fontSize : '12px'}" v-b-modal="componentId+'-modal-save'"></i>
      <i class="bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
         v-bind:style="{ fontSize : '12px'}"></i>
    </div>

    <l-map
        :zoom="zoom"
        :center="center"
        @update:zoom="zoomUpdated"
        @update:center="centerUpdated"
        :style="{ height: this.mapHeight, width: '100%'}"
        :id="componentId+'map'"
    >
        <l-tile-layer layerType="base"  v-for="baseLayer in baseLayers" :key="baseLayer.name" :name="baseLayer.name" :url="baseLayer.url" :attribution="baseLayer.attribution" />


      <l-control-layers :collapsed="true"></l-control-layers>
      <l-layer-group layerType="overlay" v-for="code in depthCodes" :key="code.depth"
                     :name="code.depth" :visible="code.visible">
        <v-marker-cluster :options="clusterOptions">
          <div v-for="(circle,index) in circles.filter(({depth}) => depth === code.depth)" v-bind:key="index">
            <l-circle-marker v-for="(point,index_point) in circle.coordinate"
                             v-bind:key="index_point"
                             :lat-lng="point.center"
                             :radius="point.radius"
                             :color="circle.color">
              <l-tooltip> {{ 'Depth : ' + code.depth }}<br> {{ 'Date : ' + point.date }}<br>{{
                  point.text
                }}<br>{{ 'Relative abundance : ' + point.value }}
              </l-tooltip>
            </l-circle-marker>
          </div>
        </v-marker-cluster>
      </l-layer-group>


      <l-layer-group ref="features">
        <l-marker v-for="(station,index) in stations"
                  v-bind:key="index"
                  :lat-lng="station.coordinate"
                  :icon="icon">
          <l-tooltip>{{ station.station_name }}</l-tooltip>
        </l-marker>
      </l-layer-group>
    </l-map>


    <b-modal :id="componentId+'-modal'" title="Sampling Site Map">
      <div class="form-group mt-2" style="font-size: 1.6vmin;">
        <template>
          <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
                :id="componentId+'radio-group-2'"
                v-model="fraction"
                :options="fractions"
                :aria-describedby="ariaDescribedby"
                name="fraction-options"
            ></b-form-radio-group>
          </b-form-group>
        </template>
        <div class="mt-2">
          <b-form-group label="Taxon">
            <select v-model="taxon" class="form-control">
              <optgroup v-for="(names, group) in taxons" v-bind:key="group" :label="`${group}`">
                <option v-for="option in names" v-bind:key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </optgroup>
            </select>
          </b-form-group>
        </div>
        <div class="mt-3">
          <b-form-group label="Map Height">
            <b-form-input id="input-1" v-model="mapHeight"></b-form-input>
          </b-form-group>
        </div>
      </div>
    </b-modal>
    <ExportDialog :componentId="componentId" :formattedData="flattenData" :plotData="circles" :exportFileName="exportFileName"></ExportDialog>

  </div>

</template>

<script>
import L from 'leaflet';
import {LMap, LTileLayer, LCircleMarker, LTooltip, LControlLayers, LLayerGroup} from "vue2-leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import {mapActions} from "vuex";
import axios from "axios";
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";

export default {
  name: "MapWidget",
  props: ['panelId', 'componentId', 'trigger_value', 'settings'],
  mixins: [ApiCall],
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LTooltip,
    LControlLayers,
    LLayerGroup,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    ExportDialog
  },
  data() {
    return {
      dataset: null,
      rank: null,
      searchPanelTaxon: null,

      dateStart: null,
      dateEnd: null,

      taxon: null,
      taxons: {},

      fractions: [],
      fraction: null,
      depthCodes: [],
      circles: [],
      stations: [],
      mapHeight: '290px',
      baseLayers: [
        {
            name : 'OpenStreetMap',
            url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
            attribution : '(c) OpenStreetMap'
        }
      ],
      zoom: 2,
      center: [0, 0],
      clusterOptions: {
        disableClusteringAtZoom: 9,
        chunkedLoading: true,
      },
      icon: L.icon({
        iconUrl: require("../assets/red_pin.png"),
        iconSize: [16, 16],
        iconAnchor: [0, 16]
      }),
      exportFileName: "default_map_name",
      flattenData: [],

      apiCallsInProgress: 0
    };
  },
  watch: {
    trigger_value() {
      this.updateContents()
    },
    depthCode() {
      this.getMapData()
    },
    taxon() {
      this.getMapData()
    },
    fraction() {
      this.getMapData()
    },
    center() {
      this.centerUpdated(this.center)
    },
    circles() {
      this.getFlattenData()
    }

  },

  created() {
    this.updateContents()
  },

  methods: {

    ...mapActions([
      'updateDashboardWidgetSettings',
      'cloneWidget'
    ]),



    updateContents() {
      let panel = this.$store.state.panels[this.panelId]
      this.dataset = panel.dataset
      this.rank = panel.rank
      this.searchPanelTaxon = panel.taxon
      this.dateStart = panel.dateStart
      this.dateEnd = panel.dateEnd

      this.initializeBaseLayers()
      this.initializeDepthCodes()

    },

    getMapData() {
      if (this.apiCallsInProgress > 0) {
        setTimeout(this.getPlotData, 2000)
        return
      }
      if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.searchPanelTaxon) {

        let newSettingsHash = this.dataset + this.taxon + this.fraction + this.dateStart + this.dateEnd + this.depthCode
        if (newSettingsHash === this.settings_hash) {
          return
        }
        this.settings_hash = newSettingsHash

        this.updateDashboardWidgetSettings({
          'componentId': this.componentId,
          'settings': {
            'dataset': this.dataset,
            'taxon': this.taxon,
            'fraction': this.fraction,
            'dateStart': this.dateStart,
            'dateEnd': this.dateEnd,
            'depths': this.depthCodes,
            'stations': this.stations
          }
        })

        let me = this
        let taxonSelectValue = this.taxon
        let words = taxonSelectValue.split('@')
        let rank = words[0]
        let taxon = words[1]
        let depthCodesList = JSON.stringify(this.depthCodes)
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['abundances_with_coordinates',
            this.dataset, rank, taxon, this.fraction, this.dateStart, this.dateEnd, depthCodesList]))
            .then(function (response) {
              me.circles = response.data
                console.log(me.circles)
            })
      } else {
        console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
      }
    },

    initializeBaseLayers() {
      if (this.dataset) {
        let me = this
        me.apiCallsInProgress++
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath, ['base_layers', this.dataset]))
            .then(function(response) {
              if (response.data.length > 0) {
                if (me.settings['restore']) {
                  me.baseLayers = me.settings['baseLayers']
                } else {
                  me.baseLayers = response.data
                }
                me.apiCallsInProgress--
              }
            })
      }
    },

    initializeDepthCodes() {
      this.depthCodes = []
      if (this.dataset) {
        let me = this
        me.apiCallsInProgress++
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['depth_codes',this.dataset]))
            .then(function (response) {
              if (response.data.length > 0) {
                if (me.settings['restore']) {
                  me.depthCodes = me.settings['depths']
                } else {
                  me.depthCodes = response.data
                }
                me.apiCallsInProgress--
              }
              me.initializeStations()
              me.initializeTaxons()
              me.initializeFractionSizes()
              me.getMapData()

            })
      }
    },
    initializeDepthCode() {
      this.depthCodes = []
      if (this.dataset) {
        let me = this
        me.apiCallsInProgress++
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['depthCodes', this.dataset]))
            .then(function (response) {
              if (response.data.length > 0) {
                me.depthCodes = response.data
                if (me.settings['restore']) {
                  me.depth = me.settings['depth']
                } else {
                  me.depth = response.data[0]['depth']
                }
                me.apiCallsInProgress--
              }

            })
      }
    },
    initializeStations() {
      this.stations = []
      if (this.dataset) {
        let me = this
        me.apiCallsInProgress++
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['station_reference_coordinates', this.dataset]))
            .then(function (response) {
              if (response.data.length > 0) {
                if (me.settings['restore']) {
                  me.stations = me.settings['stations']
                } else {
                  me.stations = response.data
                }
              }
              me.apiCallsInProgress--
            })
      }
    },

    getFlattenData() {
      let me = this
      me.flattenData.splice()
      this.circles.forEach(function (layerDescribed) {
        layerDescribed.coordinate.forEach(function (samplingData) {
          me.flattenData.push({
            'depth': layerDescribed.depth,
            'location': samplingData.center,
            'date': samplingData.date,
            'value': samplingData.radius,
            "text": samplingData.text
          })
        })
      })
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;

    }
  }
};
</script>

<style>

</style>